import { get, post } from "../http";
import baseURL from "../base";

export default {
    /* pubMend */
    pubMedSearch (data) {
        // 检索接口
        return post(`${baseURL.pubMedURL}search/search`, data, {
            headers: {
                // 'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Token 123',
                'X-Requested-With': 'XMLHttpRequest'
            },
        });
    },
    pubMedFilter (data) {
        // 左侧分面
        return get(`${baseURL.pubMedURL}search/filter`, data, {
            'Authorization': 'Token 123',
            'X-Requested-With': 'XMLHttpRequest'
        });
    },
    pubMedListCkzy (data) {
        // 查看摘要
        return get(`${baseURL.pubMedURL}list/ckzy`, data);
    },
    pubMedListJour (data) {
        // 期刊分区
        return get(`${baseURL.pubMedURL}list/jour`, data);
    },
    pubMedFolderAddcases (data) {
        // 申请全文  旧
        return get(`${baseURL.pubMedURL}folder/addcases`, data);
    },
    pubMedCasesAdd (data) {
        // 申请全文  新
        return post(`${baseURL.fullText}cases/add`, data);
    },
    pubMedFolderFollow (data) {
        // 添加跟踪式检索
        return post(`${baseURL.pubMedURL}folder/follow`, data);
    },

    pubMedGetFollowId (data) {
        //查看跟踪检索式
        return get(`${baseURL.pubMedURL}folder/get-follow-id`, data);
    },

    getHistory (data) {
        //查看历史记录
        return get(`${baseURL.pubMedURL}search/get-history`, data);
    },
    delHistory (data) {
        //删除历史记录
        return get(`${baseURL.pubMedURL}search/del-history?ids=` + data);
    },
    delAllHistory (data) {
        //删除全部历史记录
        return get(`${baseURL.pubMedURL}search/del-allhistory`, data);
    },
};
